<template>
   <div class="reports-view">
      <div class="bar_title mb-8 shadow-lg">
         <p class="title_bar_text">Reporte Sendgrid</p>
         <p>Monitoreo de Bloqueos, Rebotes, Correos Inválidos y Quejas por Spam</p>
      </div>
      <div class="text-gray-800 antialiased p-3 sm:p-6 min-h-screen flex flex-col">
         <section
            class="bg-white border border-gray-200 rounded-card p-4 shadow-sm flex flex-col lg:flex-row items-start lg:items-center justify-between mb-4">
            <div class="flex flex-wrap items-center w-full lg:w-auto">
               <!-- Rango de Fechas -->
               <div
                  class="report-date-range flex items-center bg-gray-100 border border-gray-300 rounded-lg px-3 py-2 text-xs sm:text-sm text-gray-700 mr-2 mb-2 sm:mb-0">
                  <i class="fa-regular fa-calendar-days text-brand-navy mr-2"></i>
                  <span class="font-semibold text-gray-600 mr-2">Rango:</span>
                  <flat-pickr v-model="startDate" :config="datePickerConfig" class="report-date-picker"
                     placeholder="Desde" />
                  <span class="text-gray-500 mx-1">a</span>
                  <flat-pickr v-model="endDate" :config="datePickerConfig" class="report-date-picker"
                     placeholder="Hasta" />
               </div>
               <!-- Botón de Filtrar -->
               <button @click="getReportData" class="report-action-button">Filtrar</button>
            </div>
         </section>
         <section class="flex flex-wrap -mx-2 mb-4">
            <kpi-card v-for="kpi in kpiList" :key="kpi.id" :kpi="kpi" @export-excel="exportKpiToExcel"></kpi-card>
         </section>
      </div>
   </div>
</template>
<script>
import KpiCard from './partials/KpiCard.vue';
import axios from '@/axios';
import flatPickr from 'vue-flatpickr-component';
import { Spanish } from 'flatpickr/dist/l10n/es.js';
import * as XLSX from 'xlsx';
import 'flatpickr/dist/flatpickr.css';
const now = new Date();
const firstDayOfMonth = new Date(now.getFullYear(), now.getMonth(), 1);
export default {
   name: 'ReportSendgrid',
   components: {
      KpiCard,
      flatPickr
   },
   data() {
      return {
         data: {},
         kpiList: [],
         startDate: firstDayOfMonth.toISOString().split('T')[0],
         endDate: now.toISOString().split('T')[0],
         datePickerConfig: {
            dateFormat: 'Y-m-d',
            altInput: true,
            altFormat: 'd/m/Y',
            altInputClass: 'report-date-input',
            allowInput: false,
            locale: Spanish
         }
      };
   },
   methods: {
      getReportData() {
         if (!this.startDate || !this.endDate) {
            this.$vs.notify({
               title: 'Error',
               text: 'Por favor, seleccione un rango de fechas válido.',
               color: 'danger',
               position: 'top-right'
            });
            return;
         }
         this.$vs.loading();
         let me = this;
         const params = {
            start_date: this.startDate,
            end_date: this.endDate
         };
         return axios
            .get(`auth/getSendgridErrorStats`, { params: params })
            .then(function (response) {
               me.data = response.data;
               //data contains the response {bounces:[...], blocks:[...], invalid_emails:[...], spam_reports:[...]}
               me.kpiList = [
                  {
                     id: 'requests',
                     kpiTag: '• Enviados',
                     title: 'Requests (Enviados)',
                     value: response.data.stats_resume.requests,
                     rate: '0',
                     rateLabel: '',
                     subtitle: 'Correos Enviados',
                     description: 'Cantidad total de correos cuyo envío se solicitó durante el período seleccionado. Incluye mensajes que fueron entregados y otros que pudieron ser rechazados o no llegar a su destino.',
                     icon: 'fa-envelope',
                     badgeBg: 'bg-purple-50',
                     badgeText: 'text-purple-600',
                     categoryStatus: 'Requests',
                     excelFilename: ''
                  },
                  {
                     id: 'delivered',
                     kpiTag: '• Entregados',
                     title: 'Delivered (Entregados)',
                     value: response.data.stats_resume.delivered,
                     rate: '0',
                     rateLabel: '',
                     subtitle: 'Correos Entregados',
                     description: 'Cantidad de correos que fueron aceptados por el servidor de destino durante el período seleccionado. Esto confirma su recepción por el servidor, pero no garantiza que hayan llegado a la bandeja de entrada.',
                     icon: 'fa-envelope-circle-check',
                     badgeBg: 'bg-purple-50',
                     badgeText: 'text-purple-600',
                     categoryStatus: 'Delivered',
                     excelFilename: ''
                  },
                  {
                     id: 'unique_opens',
                     kpiTag: '• Leídos',
                     title: 'Opens (Leídos)',
                     value: response.data.stats_resume.unique_opens,
                     rate: '0',
                     rateLabel: '',
                     subtitle: 'Correos Abiertos',
                     description: 'Cantidad de destinatarios únicos que abrieron al menos uno de tus correos durante el período seleccionado. Permite conocer el nivel de interacción con tus mensajes, aunque una apertura no garantiza que el contenido haya sido leído.',
                     icon: 'fa-envelope-open-text',
                     badgeBg: 'bg-purple-50',
                     badgeText: 'text-purple-600',
                     categoryStatus: 'Unique Opens',
                     excelFilename: ''
                  },
                  {
                     id: 'invalid_emails',
                     kpiTag: '• Correos Inválidos',
                     title: 'Invalid Emails (Correos Inválidos)',
                     value: response.data.invalid_emails.length,
                     rate: '0',
                     rateLabel: 'del Total Enviado',
                     subtitle: 'Correos Inválidos',
                     description: 'Direcciones de correo que no son válidas o que no existen.',
                     icon: 'fa-envelope-circle-xmark',
                     badgeBg: 'bg-gray-50',
                     badgeText: 'text-gray-600',
                     categoryStatus: 'Invalid Emails',
                     excelFilename: 'SendGrid_Suppression_Invalid_Emails.xlsx'
                  },
                  {
                     id: 'blocks',
                     kpiTag: '• Bloqueos',
                     title: 'Blocks (Bloqueos)',
                     value: response.data.blocks.length,
                     rate: '0',
                     rateLabel: 'del Total Enviado',
                     subtitle: 'Correos Bloqueados',
                     description: 'Correos que no pudieron entregarse porque el servidor del destinatario los rechazó. Esto puede ocurrir por políticas de seguridad, filtros de correo o restricciones del servidor.',
                     icon: 'fa-ban',
                     badgeBg: 'bg-yellow-100',
                     badgeText: 'text-yellow-500',
                     categoryStatus: 'Blocks',
                     excelFilename: 'SendGrid_Suppression_Blocks.xlsx'
                  },
                  {
                     id: 'bounces',
                     kpiTag: '• Rebotes',
                     title: 'Bounces (Rebotes)',
                     value: response.data.bounces.length,
                     rate: '0',
                     rateLabel: 'del Total Enviado',
                     subtitle: 'Correos No Entregados',
                     description: 'Correos que no llegaron a su destinatario porque no fue posible completar la entrega. Puede deberse a una dirección inexistente, un buzón lleno o un problema permanente o temporal con el destinatario.',
                     icon: 'fa-envelope-circle-xmark',
                     badgeBg: 'bg-red-50',
                     badgeText: 'text-red-600',
                     categoryStatus: 'Bounces',
                     excelFilename: 'SendGrid_Suppression_Bounces.xlsx'
                  },
                  {
                     id: 'spam_reports',
                     kpiTag: '• Quejas por Spam',
                     title: 'Spam Reports (Quejas por Spam)',
                     value: response.data.spam_reports.length,
                     rate: '0',
                     rateLabel: 'del Total Enviado',
                     subtitle: 'Quejas por Spam',
                     description: 'Correos que los destinatarios marcaron como correo no deseado. Un número elevado de quejas puede hacer que futuros mensajes sean rechazados o terminen en la carpeta de spam.',
                     icon: 'fa-envelope-circle-xmark',
                     badgeBg: 'bg-purple-50',
                     badgeText: 'text-purple-600',
                     categoryStatus: 'Spam Reports',
                     excelFilename: 'SendGrid_Suppression_Spam_Reports.xlsx'
                  },
               ];
               me.$vs.loading.close();
            })
            .catch(function (error) {
               me.$vs.loading.close();
            });
      },
      exportKpiToExcel(kpi) {
         let me = this;
         try {
            // build the excel file with xlsx library
            const worksheet = XLSX.utils.json_to_sheet(me.data[kpi.id].map(item => ({ Email: item.email, Reason: (item && item.reason) || '' })));
            const workbook = XLSX.utils.book_new();
            XLSX.utils.book_append_sheet(workbook, worksheet, kpi.title);
            XLSX.writeFile(workbook, kpi.excelFilename);
         } catch (error) {
         } finally {
         }
      }
   },
   mounted() {
      this.getReportData();
   }
};
</script>
<style lang="scss" scoped>
.bar_title {
   background-color: #21409a;
   border-radius: 10px;
   padding: 10px 10px 10px 20px;
   color: white;
   font-size: 2.3vh;
   font-weight: 300;
}

.bg-brand-navy {
   background-color: #203E99;
}

.bg-brand-navyDark {
   background-color: #172E73;
}

.text-brand-navy {
   color: #203E99;
}

.border-brand-navy {
   border-color: #203E99;
}

.bg-brand-light {
   background-color: #EBF0FF;
}

.rounded-card {
   border-radius: 0.75rem;
}

.report-date-range {
   gap: 0.35rem;
}

.report-date-picker {
   min-width: 118px;
}

.report-action-button {
   background: linear-gradient(135deg, #203e99 0%, #3559c7 100%);
   border: 1px solid rgba(32, 62, 153, 0.18);
   border-radius: 0.85rem;
   box-shadow: 0 12px 24px rgba(32, 62, 153, 0.16);
   color: #fff;
   cursor: pointer;
   font-size: 0.9rem;
   font-weight: 600;
   margin-top: 0.5rem;
   min-height: 44px;
   padding: 0.7rem 1.2rem;
   transition: transform 0.2s ease, box-shadow 0.2s ease, filter 0.2s ease;
}

.report-action-button:hover {
   box-shadow: 0 16px 30px rgba(32, 62, 153, 0.22);
   filter: brightness(1.03);
   transform: translateY(-1px);
}

.report-action-button:focus {
   outline: none;
   box-shadow: 0 0 0 3px rgba(32, 62, 153, 0.18), 0 16px 30px rgba(32, 62, 153, 0.22);
}

@media (min-width: 640px) {
   .report-action-button {
      margin-top: 0;
   }
}

::v-deep .report-date-input {
   background: transparent;
   border: 0;
   box-shadow: none;
   color: #1f2937;
   cursor: pointer;
   font-size: 0.95rem;
   font-weight: 500;
   line-height: 1.25rem;
   min-width: 118px;
   padding: 0;
}

::v-deep .report-date-input:focus {
   border: 0;
   box-shadow: none;
   outline: none;
}

/* Scrollbar personalizado para compatibilidad */
.custom-scrollbar::-webkit-scrollbar {
   height: 6px;
   width: 6px;
}

.custom-scrollbar::-webkit-scrollbar-track {
   background: #EDF2F7;
}

.custom-scrollbar::-webkit-scrollbar-thumb {
   background: #CBD5E0;
   border-radius: 4px;
}
</style>
